module.exports = __webpack_public_path__ + "static/media/autokar (4).bbce5787.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wynajem/autokar (4).jpg
// module id = 844
// module chunks = 0